<app-alert></app-alert>


<section class="card">

  <div class="card-header">
    <span class="cat__core__title">
      <strong id="pageTitle">Register of Bank Account Particulars</strong>
    </span>

    <span style="float: right">
      &nbsp;

      <!-- <a routerLink="/masterbankparticulars"> -->
        <button (click)="back()" class="btn btn-sm btn-default pull-right btn-back" type="button">
          <i class=" fa fa-chevron-circle-left"></i>
          Back
        </button>
      <!-- </a> -->
    </span>
    <!-- <span style="float:right">
      <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()" type="button" *ngIf="restrictTabflag">
        <span>
          <i class="fa fa-save"></i>Generate Output</span>
      </button>
</span> -->
  </div>
  <div class="row">
    <div class="col-lg-12" id="directorTabContainer">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" href="javascript: void(0);" data-toggle="tab" data-target="#bankaccountparticulars" [appHasPermission]="{'Url': '/register/masterbankparticulars/edit?goveva=true&email=', 'method':'put', 'menu': 'masterbankparticulars'}"
            role="tab">
            Bank Account Particulars
          </a>
        </li>
        <li class="nav-item">
          <a *ngIf="restrictTabflag" class="nav-link" href="javascript: void(0);" data-toggle="tab" [appHasPermission]="{'Url': '/register/masterbankparticulars/edit?goveva=true&email=', 'method':'put', 'menu': 'masterbankparticulars'}"
            data-target="#lockerdetails" role="tab">
            Locker details
          </a>
        </li>
        <li class="nav-item">
          <a *ngIf="restrictTabflag" class="nav-link" href="javascript: void(0);" data-toggle="tab" [appHasPermission]="{'Url': '/register/masterbankparticulars/edit?goveva=true&email=', 'method':'put', 'menu': 'masterbankparticulars'}"
            data-target="#depositdetails" role="tab">

            Deposit Details
          </a>
        </li>
        <li class="nav-item">
          <a *ngIf="restrictTabflag" class="nav-link" href="javascript: void(0);" data-toggle="tab" [appHasPermission]="{'Url': '/register/masterbankparticulars/edit?goveva=true&email=', 'method':'put', 'menu': 'masterbankparticulars'}"
            data-target="#loandetails" role="tab">
            Loan Details
          </a>
        </li>
        <li class="nav-item">
          <a *ngIf="restrictTabflag" class="nav-link" href="javascript: void(0);" data-toggle="tab" [appHasPermission]="{'Url': '/register/masterbankparticulars/edit?goveva=true&email=', 'method':'put', 'menu': 'masterbankparticulars'}"
            data-target="#closureofbankaccount" role="tab">
            Closure of Bank Account </a>
        </li>

      </ul>
      <div class="tab-content">
        <!-- bank account particulars -->
        <div class="tab-pane active" id="bankaccountparticulars" role="tabcard">
          <div class="modal-body">

            <div class="form-group col-sm-12 col-lg-12">
              <div class="row">
                <form [formGroup]='tcsform' (document:click)="a.close();c.close();d.close()">
                  <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>Name of the Bank</label>
                      <span _ngcontent-c2="" style="color: red;">*</span>
                      <input type="text" class="form-control" [formControl]="tcsform.controls['nameofthedocument']" (keydown)="noBlankSpaceAtStart($event)">
                      <div
                        *ngIf="tcsform.controls['nameofthedocument'].hasError('pattern') && tcsform.controls['nameofthedocument'].touched"
                        class="form-control-error-custom">
                        Name of Bank is invalid.
                      </div>
                      <div
                        *ngIf="tcsform.controls['nameofthedocument'].hasError('required') && tcsform.controls['nameofthedocument'].touched"
                        class="form-control-error-custom">
                        Name of Bank is required.
                      </div>
                    </div>

                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>Name of the Branch </label>
                      <span _ngcontent-c2="" style="color: red;">*</span>
                      <input type="text" class="form-control" [formControl]="tcsform.controls['nameofthebranch']">
                      <div
                        *ngIf="tcsform.controls['nameofthebranch'].hasError('pattern') && tcsform.controls['nameofthebranch'].touched"
                        class="form-control-error-custom">
                        Name of the Branch is invalid.
                      </div>
                      <div
                        *ngIf="tcsform.controls['nameofthebranch'].hasError('required') && tcsform.controls['nameofthebranch'].touched"
                        class="form-control-error-custom">
                        Name of the Branch is required.
                      </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>Address of the Bank</label>
                      <span _ngcontent-c2="" style="color: red;">*</span>
                      <input type="text" class="form-control" [formControl]="tcsform.controls['addressofthebank']">
                      <!-- <div *ngIf="tcsform.controls['addressofthebank'].hasError('pattern') && tcsform.controls['addressofthebank'].touched" class="form-control-error-custom">
                        address of the bank is invalid.
                      </div> -->
                      <div
                        *ngIf="tcsform.controls['addressofthebank'].hasError('required') && tcsform.controls['addressofthebank'].touched"
                        class="form-control-error-custom">
                        Address of the Bank is required.
                      </div>

                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>Contact No. of the Bank</label>
                      <span _ngcontent-c2="" style="color: red;">*</span>
                      <input type="text" class="form-control" [formControl]="tcsform.controls['contactofthebank']"
                        (keydown)="onlyNumber($event)">
                      <div
                        *ngIf="(tcsform.controls['contactofthebank'].hasError('minlength') || tcsform.controls['contactofthebank'].hasError('maxlength')) && tcsform.controls['contactofthebank'].touched"
                        class="form-control-error-custom">
                        Contact No. of the Bank is invalid.</div>
                      <div
                        *ngIf="tcsform.controls['contactofthebank'].hasError('required') && tcsform.controls['contactofthebank'].touched"
                        class="form-control-error-custom">
                        Contact No. of the Bank is required.</div>
                    </div>

                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>Type of Account</label>
                      <span _ngcontent-c2="" style="color: red;">*</span>
                      <select _ngcontent-c2="" class="form-control ng-pristine ng-valid ng-touched" name="typeofaccount"
                        [formControl]="tcsform.controls['typeofaccount']" style="padding:6px;" required>
                        <option _ngcontent-c2="" value="null" selected disabled>Select Account Type</option>
                        <option _ngcontent-c2="" value="CC">CC</option>
                        <option _ngcontent-c2="" value="Current">Current</option>
                        <option _ngcontent-c2="" value="Locker"> Locker</option>
                        <option _ngcontent-c2="" value="OD">OD </option>
                        <option _ngcontent-c2="" value="Savings">Savings </option>
                        <option _ngcontent-c2="" value="Term Loan">Term Loan (Short term / Long term)</option>
                        <option _ngcontent-c2="" value="Others">Others</option>
                        <div
                          *ngIf="tcsform.controls['typeofaccount'].invalid && tcsform.controls['typeofaccount'].touched"
                          class="form-control-error-custom">
                          Type of Account is required.</div>
                      </select>

                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>Bank Account Number</label>
                      <span _ngcontent-c2="" style="color: red;">*</span>
                      <input type="text" class="form-control" [formControl]="tcsform.controls['bankaccountnumber']"
                        (keydown)="onlyNumber($event)">
                      <div
                        *ngIf="(tcsform.controls['bankaccountnumber'].hasError('minlength') || tcsform.controls['bankaccountnumber'].hasError('maxlength')) && tcsform.controls['bankaccountnumber'].touched"
                        class="form-control-error-custom">
                        Bank Account Number is invalid.</div>
                      <div
                        *ngIf="tcsform.controls['bankaccountnumber'].hasError('required') && tcsform.controls['bankaccountnumber'].touched"
                        class="form-control-error-custom">
                        Bank Account Number is required.</div>

                    </div>
                  </div>

                  <div class="row">

                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label> IFSC Code </label>
                      <span _ngcontent-c2="" style="color: red;">*</span>
                      <input type="text" class="form-control" [formControl]="tcsform.controls['ifsc']">
                      <div *ngIf="tcsform.controls['ifsc'].hasError('pattern') && tcsform.controls['ifsc'].touched"
                        class="form-control-error-custom">
                        IFSC Code is invalid.</div>
                      <div *ngIf="tcsform.controls['ifsc'].hasError('required') && tcsform.controls['ifsc'].touched"
                        class="form-control-error-custom">
                        IFSC Code is required.</div>
                    </div>

                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label> Date of passing resolution to open bank account </label>
                      <span _ngcontent-c2="" style="color: red;">*</span>
                      <div class="input-group" (click)="$event.stopPropagation()">
                        <input class="form-control" [formControl]="tcsform.controls['dateofpassing']"
                          [(ngModel)]="dateofpassing" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                          name="dateofpassing" ngbDatepicker #a="ngbDatepicker" (click)="a.toggle()">
                        <button class="input-group-addon" (click)="a.toggle()" type="button">
                          <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                        </button>
                      </div>
                      <div
                        *ngIf="tcsform.controls['dateofpassing'].hasError('required') && tcsform.controls['dateofpassing'].touched"
                        class="form-control-error-custom">
                        Date of passing resolution to open bank account is required.</div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label class="form-control-label"> Is there any change?</label>
                      <div class="form-group">
                        <div class="md-radio md-radio-inline">
                          <input id="changeyes" type="radio" [formControl]="tcsform.controls['isthereanychange']"
                            style="position:absolute" value="true" name="change" class="form-check-input"
                            (click)="showchangeYesClick()">
                          <label for="changeyes" ng-model="Yes">Yes</label>
                        </div>
                        <div class="md-radio md-radio-inline">
                          <input id="changeno" type="radio" value="false"
                            [formControl]="tcsform.controls['isthereanychange']" style="position:absolute" name="change"
                            class="form-check-input" (click)="hidechangeyesClick()">
                          <label for="changeno" ng-model="No">No</label>
                        </div>

                      </div>
                    </div>

                    
                   
                    <div _ngcontent-c2="" class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf='showchangeYes'>
                      <label> Date of passing resolution </label>
                      <div class="input-group" (click)="$event.stopPropagation()">
                        <input class="form-control" [formControl]="tcsform.controls['yesdateofpassingresolution']"
                          [(ngModel)]="yesdateofpassingresolution" style="padding:6px;z-index: 0;"
                          placeholder="dd-mm-yyyy" name="yesdateofpassingresolution" ngbDatepicker #b="ngbDatepicker"
                          (click)="b.toggle();a.close();c.close();d.close()">
                        <button class="input-group-addon" (click)="b.toggle();a.close();c.close();d.close()" type="button">
                          <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                        </button>
                      </div>
                    </div>
                   
                  </div>

                  <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label> Date of Board Resolution authorising operation of locker</label>
                      <div class="input-group" (click)="$event.stopPropagation()">
                        <input class="form-control" [formControl]="tcsform.controls['dateofboardresolution']"
                          [(ngModel)]="dateofboardresolution" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                          name="dateofboardresolution" ngbDatepicker #c="ngbDatepicker" (click)="c.toggle()">
                        <button class="input-group-addon" (click)="c.toggle()" type="button">
                          <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                        </button>
                      </div>
                    </div>

                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label> Date of passing Board Resolution for getting Term Loan / CC / OD facility </label>
                      <div class="input-group" (click)="$event.stopPropagation()">
                        <input class="form-control" [formControl]="tcsform.controls['dateofpassingboardterminal']"
                          [(ngModel)]="dateofpassingboardterminal" style="padding:6px;z-index: 0;"
                          placeholder="dd-mm-yyyy" name="dateofpassingboardterminal" ngbDatepicker #d="ngbDatepicker"
                          (click)="d.toggle()">
                        <button class="input-group-addon" (click)="d.toggle()" type="button">
                          <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                        </button>
                      </div>

                    </div>

                    <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
                      <label>Authorized Signatory with Designation </label>
                      <select _ngcontent-c2="" class="form-control ng-pristine ng-valid ng-touched"
                        [formControl]="tcsform.controls['authorizedsignatory']" style="padding:6px;">
                        <option _ngcontent-c2="" value="" selected>Select Authorized Type</option>
                        <option _ngcontent-c2="" value="Jointly"> Jointly </option>
                        <option _ngcontent-c2="" value="Severally"> Severally </option>
                      </select>

                    </div>


                  </div>

                  <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label> Name of Authorised Signatory </label>
                      <input type="text" class="form-control" [formControl]="tcsform.controls['nameofsignatoryn']">
                      <div
                        *ngIf="tcsform.controls['nameofsignatoryn'].hasError('pattern') && tcsform.controls['nameofsignatoryn'].touched"
                        class="form-control-error-custom">
                        Name of Authorised Signatory is invalid
                      </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label> Designation of Authorised Signatory </label>
                      <input type="text" class="form-control"
                        [formControl]="tcsform.controls['designationofauthorizedsignatory']">

                    </div>

                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label> Limit of Transaction Amount for Individual </label>
                      <input type="text" class="form-control" [formControl]="tcsform.controls['limitoftransaction']">
                    </div>
                  </div>

                  <div class="form-group" align="right" *ngIf="!restrictTabflag">
                    <button class="btn btn-sm btn-primary" (click)="saveBankAccountParticular()" type="button"
                      [disabled]="!(tcsform.valid) || disabledOnclick ">
                      <span>
                        <i class="fa fa-save"></i>Save </span>
                    </button>
                  </div>
                  <div class="form-group" align="right" *ngIf="restrictTabflag">
                    <button class="btn btn-sm btn-primary" (click)="updateBankAccountParticulars()" type="button"
                      [disabled]="!(tcsform.valid) || disabledOnclick">
                      <span>
                        <i class="fa fa-save"></i>Update </span>
                    </button>
                  </div>
                </form>
              </div>
            </div>

          </div>
        </div>

        <!-- locker details -->
        <div class="tab-pane" id="lockerdetails" role="tabcard">
          <div class="modal-body">
            <div class="form-group">
              <form [formGroup]='lockerdetailsform' (document:click)="e.close()">
                <div class="row">
                  <div class=" form-group col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label"> Locker no. </label>
                    <div class="form-group">
                      <input type="text" class="form-control" minlength="1"
                        [formControl]="lockerdetailsform.controls['lockernumber']">
                      <div
                        *ngIf="lockerdetailsform.controls['lockernumber'].hasError('minlength') && lockerdetailsform.controls['lockernumber'].touched"
                        class="form-control-error-custom">
                        Locker number is invalid.</div>
                    </div>
                  </div>

                  <!-- date  -->
                  <!-- <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label"> Due date for payment of locker fees </label>
                    <div class="input-group">
                      <input class="form-control" [formControl]="lockerdetailsform.controls['dateforpayemntlockerfee']"
                        [(ngModel)]="dateforpayemntlockerfee" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                        name="dateforpayemntlockerfee" ngbDatepicker #e="ngbDatepicker" (click)="e.toggle()">
                      <button class="input-group-addon" (click)="e.toggle()" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div> -->
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>Due date for payment of locker fees </label>
                      <div class="input-group" (click)="$event.stopPropagation()">
                        <input class="form-control" [formControl]="lockerdetailsform.controls['dateforpayemntlockerfee']"
                          [(ngModel)]="dateforpayemntlockerfee" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                          name="dateforpayemntlockerfee" ngbDatepicker #e="ngbDatepicker" (click)="e.toggle()">
                        <button class="input-group-addon" (click)="e.toggle()" type="button">
                          <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                        </button>
                      </div>
                    </div>
                  <div class="col-md-4   ">
                    <label class="form-control-label"> Amount of Locker fees </label>
                    <div class="form-group">
                      <input type="text" class="form-control" (keydown)="noBlankSpaceAtStart($event)"
                        [formControl]="lockerdetailsform.controls['amountlockerfee']">
                      <!-- <div *ngIf="lockerdetailsform.controls['amountlockerfee'].hasError('pattern') && lockerdetailsform.controls['amountlockerfee'].touched"
                        class="form-control-error-custom">
                        Amount of Locker fees is invalid.</div> -->
                    </div>
                  </div>


                </div>

                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Details of locker surrendered, if any </label>
                    <input type="text" class="form-control"
                      [formControl]="lockerdetailsform.controls['detailslockersurrender']">
                  </div>
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label> Number of lockers in use</label>
                    <input type="text" class="form-control"
                      [formControl]="lockerdetailsform.controls['numberlockeruse']" (keydown)="onlyNumber($event)">
                    <!-- <div *ngIf="lockerdetailsform.controls['numberlockeruse'].hasError('pattern') && lockerdetailsform.controls['numberlockeruse'].touched"
                      class="form-control-error-custom">
                      Details of locker surrendered is invalid</div> -->
                  </div>
                </div>
              </form>
              <div class="form-group" align="right" *ngIf="addLockerBtn">
                <button class="btn btn-sm btn-primary" (click)="saveLockerFormEntry()" type="button"
                  [disabled]="!lockerdetailsform.valid || disabledOnclick ">
                  <span id="saveUpdateDirector">
                    <i class="fa fa-save"></i>
                    Save
                  </span>
                </button>
              </div>
              <div class="form-group" align="right" *ngIf="!addLockerBtn">
                <button class="btn btn-sm btn-primary" (click)="saveLockerFormEntry()" type="button"
                  [disabled]="!lockerdetailsform.valid || disabledOnclick ">
                  <span id="saveUpdateDirector">
                    <i class="fa fa-save"></i>
                    Update
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- depositdetails -->

        <div class="tab-pane" id="depositdetails" role="tabcard">
          <div class="modal-body">
            <div class="form-group ">

              <form [formGroup]='depositdetailsform' (document:click)="f.close();g.close();h.close();i.close()">
                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label> Deposit ID </label>
                    <input type="text" class="form-control" [formControl]="depositdetailsform.controls['depositID']">
                  </div>

                  <!-- date -->
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label> Date of Opening of Deposit with Bank </label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="depositdetailsform.controls['dateofopeningdeposit']"
                        [(ngModel)]="dateofopeningdeposit" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                        name="dateofopeningdeposit" ngbDatepicker #f="ngbDatepicker" (click)="f.toggle()">
                      <button class="input-group-addon" (click)="f.toggle()" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label> Amount of Deposit </label>
                    <input type="text" class="form-control" [formControl]="depositdetailsform.controls['amountdeposit']"
                      (keydown)="onlyNumber($event)">
                    <div *ngIf="depositdetailsform.controls['amountdeposit'].hasError('pattern') && depositdetailsform.controls['amountdeposit'].touched"
                      class="form-control-error-custom">
                      Amount of Deposit is invalid</div>

                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Rate of interest (in %) </label>
                    <input type="text" class="form-control"
                      [formControl]="depositdetailsform.controls['rateofinterestdeposit']"
                      (keydown)="onlyNumber($event)">

                  </div>

                  <!-- date -->
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label> Date of Maturity of Deposit</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="depositdetailsform.controls['dateofmaturity']"
                        [(ngModel)]="dateofmaturity" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                        name="dateofmaturity" ngbDatepicker #g="ngbDatepicker" (click)="g.toggle()">
                      <button class="input-group-addon" (click)="g.toggle()" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>


                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label> Maturity Amount</label>
                    <input type="text" class="form-control"
                      [formControl]="depositdetailsform.controls['maturityamount']" (keydown)="onlyNumber($event)">
                    <!-- <div *ngIf="depositdetailsform.controls['maturityamount'].hasError('pattern') && depositdetailsform.controls['maturityamount'].touched"
                      class="form-control-error-custom">
                      Maturity Amount is invalid</div> -->

                  </div>


                </div>

                <div class="row">
                  <!-- <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Maturity Amount </label>
                    <input type="text" class="form-control" [formControl]="depositdetailsform.controls['nameofsignatoryn']" [(ngModel)]="nameofsignatoryn" >
                  
                  </div> -->
                  <!-- date -->
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label> Date of receipt of Deposit</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="depositdetailsform.controls['dateofreceiptdeposit']"
                        [(ngModel)]="dateofreceiptdeposit" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                        name="dateofreceiptdeposit" ngbDatepicker #h="ngbDatepicker" (click)="h.toggle()">
                      <button class="input-group-addon" (click)="h.toggle()" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label> Prematured Amount, if any </label>
                    <input type="text" class="form-control"
                      [formControl]="depositdetailsform.controls['prematuredamount']" (keydown)="onlyNumber($event)">
                    <div *ngIf="depositdetailsform.controls['prematuredamount'].hasError('pattern') && depositdetailsform.controls['prematuredamount'].touched"
                      class="form-control-error-custom">
                      Prematured Amount is invalid</div>
                  </div>
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label> Date of Prematurity </label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="depositdetailsform.controls['dateofprematurity']"
                        [(ngModel)]="dateofprematurity" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                        name="dateofprematurity" ngbDatepicker #i="ngbDatepicker" (click)="i.toggle()">
                      <button class="input-group-addon" (click)="i.toggle()" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label> Reasons for prematurity, if any </label>
                    <input type="text" class="form-control"
                      [formControl]="depositdetailsform.controls['reasonofprematurity']">
                  </div>
                </div>

              </form>


              <div class="form-group" align="right" *ngIf="addDepositBtn">
                <button class="btn btn-sm btn-primary" (click)="saveDepositFormEntry()" type="button"
                  [disabled]="!(depositdetailsform.valid) || disabledOnclick ">
                  <span id="saveUpdateDirector">
                    <i class="fa fa-save"></i>&nbsp;Save
                  </span>
                </button>
              </div>
              <div class="form-group" align="right" *ngIf="!addDepositBtn">
                <button class="btn btn-sm btn-primary" (click)="saveDepositFormEntry()" type="button"
                  [disabled]="!(depositdetailsform.valid) || disabledOnclick ">
                  <span id="saveUpdateDirector">
                    <i class="fa fa-save"></i>&nbsp;Update
                  </span>
                </button>
              </div>
            </div>


          </div>
        </div>

        <!-- loan details -->
        <div class="tab-pane" id="loandetails" role="tabcard">
          <div class="modal-body">

            <div class="form-group col-sm-12 col-lg-12">

              <form [formGroup]='loandetailsform' (document:click)="k.close()">
                <div class="row">
                  <!-- <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label> Sr.No. of Term loan  </label>
                    <input type="text" class="form-control" [formControl]="loandetailsform.controls['autotermloan']" [(ngModel)]="autotermloan" >
                  
                  </div> -->
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label> Loan ID </label>
                    <input type="text" class="form-control" [formControl]="loandetailsform.controls['loanID']">
                  </div>

                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label> Type of Loan </label>
                    <select _ngcontent-c2="" class="form-control ng-pristine ng-valid ng-touched"
                      [formControl]="loandetailsform.controls['typeofloan']" placeholder="select type of loan"
                      style="padding:6px;" (change)="changedTypeofloan($event)">
                      <option _ngcontent-c2="" value="null" selected>Select Account Type</option>
                      <option _ngcontent-c2="" value="CC">CC / OD Facility</option>
                      <option _ngcontent-c2="" value="Term Loan">Term Loan (Short term / Long term)</option>
                    </select>
                  </div>

                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label> Sum Borrowed </label>
                    <input type="text" class="form-control" (keydown)="onlyNumber($event)"
                      [formControl]="loandetailsform.controls['sumborrowed']">

                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label> Rate of interest (in %)</label>
                    <input type="text" class="form-control" (keydown)="onlyNumber($event)"
                      [formControl]="loandetailsform.controls['rateofinterestloan']">
                  </div>
                  <div *ngIf="showTermLoadFields" class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label> Amount of EMI </label>
                    <input type="text" class="form-control" (keydown)="onlyNumber($event)"
                      [formControl]="loandetailsform.controls['amountemi']">
                  </div>

                  <!-- date -->
                  <div *ngIf="showTermLoadFields" class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label> Due date of EMI </label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="loandetailsform.controls['dateofemi']"
                        [(ngModel)]="dateofemi" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                        name="dateofemi" ngbDatepicker #j="ngbDatepicker" (click)="j.toggle();k.close()">
                      <button class="input-group-addon" (click)="j.toggle();k.close()" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="row">

                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label> Securities provided, if any </label>
                    <input type="text" class="form-control"
                      [formControl]="loandetailsform.controls['securitiesprovide']">
                  </div>

                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label> Charges registered, if any </label>
                    <input type="text" class="form-control"
                      [formControl]="loandetailsform.controls['chargesregistered']">
                    <!-- <div class="form-group">
                      <div class="md-radio md-radio-inline">
                        <input id="changeyes" type="radio"
                          [formControl]="loandetailsform.controls['ischargesregistered']"
                          [checked]="loandetailsform.controls['ischargesregistered'].value" style="position:absolute"
                          value="true" name="change" class="form-check-input" (click)="chargesRegisteredYesClick()">
                        <label for="changeyes" ng-model="Yes">Yes</label>
                      </div>
                      <div class="md-radio md-radio-inline">
                        <input id="changeno" type="radio" value="false"
                          [formControl]="loandetailsform.controls['ischargesregistered']"
                          [checked]="loandetailsform.controls['ischargesregistered'].value==false"
                          style="position:absolute" name="change" class="form-check-input"
                          (click)="chargesRegisteredNoClick()">
                        <label for="changeno" ng-model="No">No</label>
                      </div>

                    </div> -->

                  </div>

                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label> Date of repayment of Loan Amount </label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="loandetailsform.controls['dateofrepaymentloanamount']"
                        [(ngModel)]="dateofrepaymentloanamount" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                        name="dateofrepaymentloanamount" ngbDatepicker #k="ngbDatepicker" (click)="k.toggle()">
                      <button class="input-group-addon" (click)="k.toggle()" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>

                  <!-- <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="showchargesregistered">
                    <label> Reference to charge ID in CHG 7 </label>
                    <input type="text" class="form-control"
                      [formControl]="loandetailsform.controls['chargesregistered']">
                  </div> -->

                  <!-- date -->

                </div>


              </form>

              <div class="form-group" align="right" *ngIf="addLoanBtn">
                <button class="btn btn-sm btn-primary" (click)="saveloanFormEntry()" type="button"
                  [disabled]="!(loandetailsform.valid) || disabledOnclick ">
                  <span>
                    <i class="fa fa-save"></i>&nbsp;Save
                  </span>
                </button>
              </div>
              <div class="form-group" align="right" *ngIf="!addLoanBtn">
                <button class="btn btn-sm btn-primary" (click)="saveloanFormEntry()" type="button"
                  [disabled]="!(loandetailsform.valid) || disabledOnclick">
                  <span>
                    <i class="fa fa-save"></i>&nbsp;Update
                  </span>
                </button>
              </div>

            </div>
          </div>

        </div>


        <!-- closure of bank -->

        <div class="tab-pane" id="closureofbankaccount" role="tabcard">
          <div class="modal-body">
            <div class="form-group col-sm-12 col-lg-12">

              <form [formGroup]='closureofbankaccountform' (document:click)="l.close();m.close()">
                <!-- date -->
                <div class="row">
                  <div class="form-group col-md-4 ">
                    <label> Date of Closure of Bank account, if any </label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="closureofbankaccountform.controls['dateofclosure']"
                        [(ngModel)]="dateofclosure" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                        name="dateofclosure" ngbDatepicker #l="ngbDatepicker" (click)="l.toggle();">
                      <button class="input-group-addon" (click)="l.toggle();" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>

                  <!-- date -->
<!-- 
                  <div class="form-group col-md-4 ">
                    <label>Date of passing resolution to close bank account</label>
                    <div class="input-group">
                      <input class="form-control"
                        [formControl]="closureofbankaccountform.controls['dateofpassingresolution']"
                        [(ngModel)]="dateofpassingresolution" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                        name="dateofpassingresolution" ngbDatepicker #m="ngbDatepicker" (click)="m.toggle();">
                      <button class="input-group-addon" (click)="m.toggle();" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div> -->
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label> Date of passing resolution to close bank account</label>
                      <div class="input-group" (click)="$event.stopPropagation()">
                        <input class="form-control" [formControl]="closureofbankaccountform.controls['dateofpassingresolution']"
                          [(ngModel)]="dateofpassingresolution" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                          name="dateofpassingresolution" ngbDatepicker #m="ngbDatepicker" (click)="m.toggle()">
                        <button class="input-group-addon" (click)="m.toggle()" type="button">
                          <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                        </button>
                      </div>
                    </div>

                  <div class="form-group col-md-4 ">
                    <label> Remarks, if any </label>
                    <textarea class="form-control"
                      [formControl]="closureofbankaccountform.controls['remarks']"></textarea>
                  </div>
                </div>

              </form>

              <div class="form-group" align="right" *ngIf="addClosureBtn">
                <button class="btn btn-sm btn-primary" (click)="saveClosureFormEntry()" type="button"
                  [disabled]="!(closureofbankaccountform.valid) || disabledOnclick ">
                  <span> <i class="fa fa-save"></i> &nbsp;Save </span>
                </button>
              </div>
              <div class="form-group" align="right" *ngIf="!addClosureBtn">
                <button class="btn btn-sm btn-primary" (click)="saveClosureFormEntry()" type="button"
                  [disabled]="!(closureofbankaccountform.valid) || disabledOnclick ">
                  <span> <i class="fa fa-save"></i>&nbsp; Update </span>
                </button>
              </div>
            </div>

          </div>

        </div>

      </div>
    </div>

  </div>


  <!-- <div class="card-footer">
        </div> -->
</section>